// /utils/checkoutValidationSchemas.js
import * as Yup from "yup";

// ─────────────────────────────────────────────────────────────────────────────
// 1. Define individual schemas for each service
// ─────────────────────────────────────────────────────────────────────────────p

// VPS Schema
const vpsSchema = Yup.object().shape({
	configuration: Yup.object().shape({
		serverName: Yup.string().required(),

		os: Yup.object().shape({
			id: Yup.string().required("OS is required"),
		}),

		additionalIp: Yup.object().shape({
			id: Yup.string().required("Additional IP is required"),
		}),

		// Payment fields
		paymentMethod: Yup.object().shape({
			module: Yup.string().required("Payment method is required"),
		}),
		paymentCycle: Yup.string().required("Payment cycle is required"),
		paymentProfile: Yup.object().shape({
			id: Yup.number().required("Profile ID is required"),
			authorized: Yup.boolean().oneOf([true], "Profile must be authorized"),
		}),
	}),
});

// Baremetal Schema
const baremetalSchema = Yup.object().shape({
	configuration: Yup.object().shape({
		serverName: Yup.string().required(),

		os: Yup.object().shape({
			id: Yup.string().required("OS is required"),
		}),

		additionalIp: Yup.object().shape({
			id: Yup.string().required("Additional IP is required"),
		}),

		// Payment fields
		paymentMethod: Yup.object().shape({
			module: Yup.string().required("Payment method is required"),
		}),
		paymentCycle: Yup.string().required("Payment cycle is required"),
		paymentProfile: Yup.object().shape({
			id: Yup.number().required("Profile ID is required"),
			authorized: Yup.boolean().oneOf([true], "Profile must be authorized"),
		}),
	}),
});

// Colocation Schema
const colocationSchema = Yup.object().shape({
	configuration: Yup.object().shape({
		// Payment fields
		paymentCycle: Yup.string().required("Payment cycle is required"),
		paymentMethod: Yup.object().shape({
			module: Yup.string().required("Payment method is required"),
		}),
		paymentProfile: Yup.object().shape({
			id: Yup.number().required("Profile ID is required"),
			authorized: Yup.boolean().oneOf([true], "Profile must be authorized"),
		}),
	}),
});

// Storage Schema
const storageSchema = Yup.object().shape({
	configuration: Yup.object().shape({
		// Payment fields
		paymentCycle: Yup.string().required("Payment cycle is required"),
		paymentMethod: Yup.object().shape({
			module: Yup.string().required("Payment method is required"),
		}),
		paymentProfile: Yup.object().shape({
			id: Yup.number().required("Profile ID is required"),
			authorized: Yup.boolean().oneOf([true], "Profile must be authorized"),
		}),
	}),
});

const ipTransitSchema = Yup.object().shape({
	configuration: Yup.object().shape({
		// Payment fields
		paymentCycle: Yup.string().required("Payment cycle is required"),
		paymentMethod: Yup.object().shape({
			module: Yup.string().required("Payment method is required"),
		}),
		paymentProfile: Yup.object().shape({
			id: Yup.number().required("Profile ID is required"),
			authorized: Yup.boolean().oneOf([true], "Profile must be authorized"),
		}),
	}),
});

const ultraproxySchema = Yup.object().shape({
	configuration: Yup.object().shape({
		// Payment fields
		paymentCycle: Yup.string().required("Payment cycle is required"),
		paymentMethod: Yup.object().shape({
			module: Yup.string().required("Payment method is required"),
		}),
		paymentProfile: Yup.object().shape({
			id: Yup.number().required("Profile ID is required"),
			authorized: Yup.boolean().oneOf([true], "Profile must be authorized"),
		}),
	}),
});

const bgpSchema = Yup.object().shape({
	configuration: Yup.object().shape({
		// Payment fields
		paymentCycle: Yup.string().required("Payment cycle is required"),
		paymentMethod: Yup.object().shape({
			module: Yup.string().required("Payment method is required"),
		}),
		paymentProfile: Yup.object().shape({
			id: Yup.number().required("Profile ID is required"),
			authorized: Yup.boolean().oneOf([true], "Profile must be authorized"),
		}),
	}),
});

const webHostingSchema = Yup.object().shape({
	configuration: Yup.object({
		serverName: Yup.string(),

		paymentCycle: Yup.string().required("Payment cycle is required"),
		paymentMethod: Yup.object().shape({
			module: Yup.string().required("Payment method is required"),
		}),
		paymentProfile: Yup.object().shape({
			id: Yup.number().required("Profile ID is required"),
			authorized: Yup.boolean().oneOf([true], "Profile must be authorized"),
		}),
	}),
});

// ─────────────────────────────────────────────────────────────────────────────
// 2. Define individual initialValues for each service
// ─────────────────────────────────────────────────────────────────────────────

// const vpsInitialValues = {
// 	configuration: {
// 		os: { id: "", name: "" },
// 		additionalIp: { id: "", name: "" },
// 		bgp: { id: "", enabled: false },
// 		serverName: translations?.serverNamePlaceholder || "servername.example.com",
// 		bgpSession: false,
// 		paymentCycle: "monthly",
// 		paymentMethod: { module: "", name: "" },
// 		paymentProfile: { id: 0, authorized: false },
// 	},
// };

// const baremetalInitialValues = {
// 	configuration: {
// 		os: { id: "", name: "" },
// 		additionalIp: { id: "", name: "" },
// 		bgp: { id: "", enabled: false },
// 		serverName: translations?.serverNamePlaceholder || "servername.example.com",
// 		bgpSession: false,
// 		paymentCycle: "monthly",
// 		paymentMethod: { module: "", name: "" },
// 		paymentProfile: { id: 0, authorized: false },
// 	},
// };

// const colocationInitalValues = {
// 	configuration: {
// 		bgp: { id: "", enabled: false },
// 		paymentCycle: "monthly",
// 		paymentMethod: { module: "", name: "" },
// 		paymentProfile: { id: 0, authorized: false },
// 	},
// };

// const storageInitalValues = {
// 	configuration: {
// 		paymentCycle: "monthly",
// 		paymentMethod: { module: "", name: "" },
// 		paymentProfile: { id: 0, authorized: false },
// 	},
// };

// const ipTransitInitialValues = {
// 	configuration: {
// 		paymentCycle: "monthly",
// 		paymentMethod: { module: "", name: "" },
// 		paymentProfile: { id: 0, authorized: false },
// 	},
// };

// const ultraproxyInitialValues = {
// 	configuration: {
// 		paymentCycle: "monthly",
// 		paymentMethod: { module: "", name: "" },
// 		paymentProfile: { id: 0, authorized: false },
// 	},
// };

// const bgpInitialValues = {
// 	configuration: {
// 		paymentCycle: "monthly",
// 		paymentMethod: { module: "", name: "" },
// 		paymentProfile: { id: 0, authorized: false },
// 	},
// };

// const webHostingValues = {
// 	configuration: {
// 		hasDomain: false,
// 		serverName: "",
// 		paymentCycle: "annually",
// 		paymentMethod: { module: "", name: "" },
// 		paymentProfile: { id: 0, authorized: false },
// 	},
// };

// ─────────────────────────────────────────────────────────────────────────────
// 3. Helper function to pick the correct schema based on the selected service
// ─────────────────────────────────────────────────────────────────────────────

export function getValidationSchema(serviceType) {
	// debugger;
	switch (serviceType) {
		case "baremetal":
			return baremetalSchema;
		case "vps":
			return vpsSchema;
		case "colocation":
			return colocationSchema;
		case "storage":
			return storageSchema;
		case "iptransit":
			return ipTransitSchema;
		case "ultraproxy":
			return ultraproxySchema;
		case "bgp":
			return bgpSchema;
		case "webhosting":
			return webHostingSchema;
		default:
			return vpsSchema;
	}
}

// ─────────────────────────────────────────────────────────────────────────────
// 4. Helper function to pick the correct initialValues based on the service
// ─────────────────────────────────────────────────────────────────────────────
export function getInitialValues(serviceType, translations) {
	const serverNamePlaceholder = translations?.serverNamePlaceholder || "servername.example.com";

	switch (serviceType) {
		case "baremetal":
		case "vps":
			return {
				configuration: {
					os: { id: "", name: "" },
					additionalIp: { id: "", name: "" },
					bgp: { id: "", enabled: false },
					serverName: "",
					bgpSession: false,
					paymentCycle: "monthly",
					paymentMethod: { module: "", name: "" },
					paymentProfile: { id: 0, authorized: false },
				},
			};

		case "colocation":
			return {
				configuration: {
					bgp: { id: "", enabled: false },
					paymentCycle: "monthly",
					paymentMethod: { module: "", name: "" },
					paymentProfile: { id: 0, authorized: false },
				},
			};

		case "storage":
		case "iptransit":
		case "ultraproxy":
		case "bgp":
			return {
				configuration: {
					paymentCycle: "monthly",
					paymentMethod: { module: "", name: "" },
					paymentProfile: { id: 0, authorized: false },
				},
			};

		case "webhosting":
			return {
				configuration: {
					hasDomain: false,
					serverName: "",
					paymentCycle: "annually",
					paymentMethod: { module: "", name: "" },
					paymentProfile: { id: 0, authorized: false },
				},
			};

		default:
			return {
				configuration: {
					serverName: "",
					paymentCycle: "monthly",
					paymentMethod: { module: "", name: "" },
					paymentProfile: { id: 0, authorized: false },
				},
			};
	}
}
